<template>
  <el-card>
    <el-form ref="ruleForm" label-position="top">
      <ShippingAddFormHeader ref="header" />
      <el-tabs v-model="activeTab">
        <el-tab-pane label="Dados" name="tabinfo">
          <ShippingAddFormInfo ref="info" />
        </el-tab-pane>
        <el-tab-pane :label="$t('configuracao')" name="tabconfig">
          <ShippingAddFormConfig ref="configuration" />
        </el-tab-pane>
        <el-tab-pane :label="$t('precificacao')" name="tabpricing">
          <ShippingAddFormDynamicPrice ref="dynamicpricetable" />
        </el-tab-pane>
        <el-tab-pane :label="$t('aliquota')" name="tabaliquot">
          <ShippingAddFormAliquotPrice ref="dynamicaliquottable" />
        </el-tab-pane>
        <el-tab-pane :label="$t('restricoes')" name="tabrestrict">
          <ShippingAddFormRestricted ref="restricted" :tableData="tableRestricted" @add="addRestricted"
            @edit="editRestricted" @remove="removeRestricted" />
        </el-tab-pane>
        <!--el-tab-pane :label="$t('tabela-preco')" name="tabpricetable">
          <ShippingAddFormPricetable ref="pricetable" />
        </el-tab-pane-->
      </el-tabs>
      <br />
      <ShippingAddFormFooter :updated="updated" @submit="submitForm" redirect="shipping" />
    </el-form>
  </el-card>
</template>
<script>

import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ShippingHeaderAdd from "./ShippingHeaderAdd.vue";
import ShippingAddFormConfig from './config/ShippingAddFormConfig';
import ShippingAddFormFooter from "./config/ShippingAddFormFooter.vue";
import ShippingAddFormHeader from "./config/ShippingAddFormHeader.vue";
import ShippingAddFormPricetable from './pricetable/ShippingAddFormPricetable';
import ShippingAddFormDynamicPrice from './pricetable/ShippingAddFormDynamicPrice';
import ShippingAddFormRestricted from './restricted/ShippingAddFormRestricted';
import ShippingAddFormInfo from "./info/ShippingAddFormInfo.vue";

import { ShippingService } from "@/services/shipping/shipping.services";
import ShippingAddFormAliquotPrice from "./pricetable/ShippingAddFormAliquotPrice.vue";

export default {
  name: "ShippingAddForm",
  components: {
    CustomerList,
    ShippingHeaderAdd,
    ShippingAddFormConfig,
    ShippingAddFormRestricted,
    ShippingAddFormPricetable,
    ShippingAddFormDynamicPrice,
    ShippingAddFormAliquotPrice,
    ShippingAddFormInfo,
    ShippingAddFormHeader,
    ShippingAddFormFooter
  },
  computed: {
    updated() {
      return this.id !== '';
    }
  },
  data() {
    return {
      id: "",
      tableRestricted: [],
      activeTab: "tabinfo",
    };
  },
  methods: {
    editRestricted(index, restrictedData) {
      this.tableRestricted[index] = restrictedData;
    },
    addRestricted(restrictedData) {
      this.tableRestricted.push(restrictedData);
    },
    removeRestricted(index) {
      this.tableRestricted.splice(index, 1);
    },
    selected(customer) {
      this.ruleForm.customer = customer;
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ShippingService.findById(vm.id)
        .then((response) => {
          vm.$refs.header.ruleForm = response;
          vm.$refs.info.setData(response);
          vm.$refs.configuration.setData(response);
          vm.$refs.dynamicpricetable.setData(response);
          vm.$refs.dynamicaliquottable.setData(response);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm() {
      // MUDAR AQUI
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const formData = {
        ...vm.$refs.header.data,
        ...vm.$refs.info.data,
        ...vm.$refs.dynamicpricetable.data(),
        ...vm.$refs.dynamicaliquottable.data(),
      }
      formData.config = vm.$refs.configuration.data;
      formData.restricted = vm.tableRestricted;
      if (vm.id) {
        ShippingService.update(vm.id, formData)
          .then((response) => {
            this.$message({
              type: "sucess",
              message: "Transportadora alterada com sucesso!",
            });
            this.$router.push({ name: "shipping" });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      } else {
        ShippingService.create(formData)
          .then((response) => {
            this.$message({
              type: "sucess",
              message: "Transportadora cadastrada com sucesso!",
            });
            this.$router.push({ name: "shipping" });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      }
    },
  },
  mounted() {
    const vm = this;
    if (vm.$route.params.id) {
      vm.id = this.$route.params.id;
      vm.get();
    }
  },
};
</script>
